var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13588_9682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2613 2.57673C15.5346 1.91969 16.4654 1.91969 16.7387 2.57672L20.0444 10.5247C20.1596 10.8017 20.4201 10.9909 20.7191 11.0149L29.2996 11.7028C30.0089 11.7597 30.2966 12.6449 29.7561 13.1078L23.2187 18.7078C22.9909 18.903 22.8914 19.2092 22.961 19.501L24.9583 27.8741C25.1234 28.5663 24.3704 29.1134 23.7631 28.7425L16.417 24.2555C16.161 24.0991 15.839 24.0991 15.583 24.2555L8.2369 28.7425C7.62962 29.1134 6.87661 28.5663 7.04172 27.8741L9.03902 19.501C9.10862 19.2092 9.00912 18.903 8.78129 18.7078L2.24386 13.1078C1.70343 12.6449 1.99105 11.7597 2.70037 11.7028L11.2809 11.0149C11.5799 10.9909 11.8404 10.8017 11.9556 10.5247L15.2613 2.57673Z",
    fill: "#E6E7EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13588_9682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.79ace3953c1ce344d162ecae8d2c70e4.svg";
export { ForwardRef as ReactComponent };